
/**
 * An object containing validation rules for form fields.
 *
 * @property {function(string): (boolean|string)} required - Validates that the value is not empty. Returns true if valid, otherwise an error message.
 * @property {function(string): (boolean|string)} pemKey - Validates that the value is in PEM key format and does not contain suspicious Unicode characters. Returns true if valid, otherwise an error message.
 * @property {function(string): (boolean|string)} endpoint - Validates that the value is a non-empty, valid URL. Returns true if valid, otherwise an error message.
 */
const validationRules = {
  required: v => !!v || 'Field is required',
  pemKey: v => {
    if (!v || v.trim() === "") return true;
    const pemFormat = /^-----BEGIN ([A-Z ]+)-----[\s\S]+-----END \1-----$/;
    if (!pemFormat.test(v.trim())) {
      return "Invalid Credential Key format";
    }
    const suspicious = new RegExp(
      ['\u00A0', '\u200B', '\u200C', '\u200D', '\uFEFF'].join('|')
    );
    if (suspicious.test(v)) {
      return "Credential Key contains suspicious characters";
    }
    return true;
  },
  endpoint: v => {
    if (!v || v.trim() === "") return true;
    const urlPattern = /^(https?:\/\/)[^\s$.?#].[^\s]*$/i;
    if (!urlPattern.test(v.trim())) {
      return "Endpoint must be a valid URL";
    }
    return true;
  }
};
export default validationRules;